module.exports = __webpack_public_path__ + "img/日月潭.2c4be66d.jpg";